<template>
  <div class="template-element">
    <div class="element-header">
      <span class="element-type-badge">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="none">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
        </svg>
        <span>Template WhatsApp</span>
      </span>
      <div class="element-actions">
        <button class="action-btn" @click.stop="$emit('duplicate')" title="Dupliquer">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect>
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>
          </svg>
        </button>
        <button class="action-btn delete-btn" @click.stop="$emit('remove')" title="Supprimer">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="3 6 5 6 21 6"></polyline>
            <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
          </svg>
        </button>
      </div>
    </div>
    
    <!-- Mode Affichage -->
    <div v-if="!isEditing" class="element-content" @click="startEditing">
      <div v-if="previewText" class="whatsapp-preview">
            <div class="message-bubble">
                {{ previewText }}
            </div>
      </div>
      <div v-else class="empty-preview">
          <span class="label">Template:</span>
          <span class="value">{{ element.templateName || 'Aucun sélectionné' }}</span>
          <span v-if="element.category" class="category-badge">{{ element.category }}</span>
      </div>

       <div class="status-indicator" v-if="selectedTemplateStatus !== 'UNKNOWN'">
        <span class="status-badge" :style="{ backgroundColor: statusColor }">{{ selectedTemplateStatus }}</span>
      </div>
      
      <div class="edit-button-overlay">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>
        </svg>
      </div>
    </div>

    <!-- Mode Édition -->
    <div v-else class="element-edit-form">
      <div class="form-group">
        <label>Compte WhatsApp (Expéditeur)</label>
        <div class="sender-info">
            <span class="phone-badge">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" stroke="none">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                </svg>
                {{ localElement.sender || 'Non configuré' }}
            </span>
             <button class="small-btn refresh-btn" @click="fetchTemplates" :disabled="loading" title="Recharger les templates">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" :class="{'spin': loading}">
                    <path d="M21.5 2v6h-6M2.5 22v-6h6M2 11.5a10 10 0 0 1 18.8-4.3M22 12.5a10 10 0 0 1-18.8 4.3"></path>
                </svg>
            </button>
        </div>
      </div>

       <div class="form-group">
        <label>Destinataire</label>
        <VariableSelector
          :value="getVariableValue(localElement.to)"
          @change="(val) => setVariableValue('to', val)"
          :variables="variables"
          :allowCustom="true"
          placeholder="ex: 221... ou choisissez une variable"
        />
      </div>

      <div class="form-group">
        <label>Sélectionner le Template</label>
        <select v-model="localElement.templateName" @change="onTemplateChange" class="form-select">
          <option value="" disabled>-- Choisir --</option>
          <option v-for="tpl in templates" :key="tpl.id" :value="tpl.name">
            {{ tpl.name }} ({{ tpl.language }}) - {{ tpl.status }}
          </option>
        </select>
      </div>

      <!-- Dynamic Parameters -->
      <div v-if="currentTemplateParams.length > 0" class="parameters-section">
          <label class="section-label">Paramètres du Template</label>
          <div v-for="param in currentTemplateParams" :key="param" class="form-group small-group">
              <label>{{ param }}</label>
              <VariableSelector
                :value="getVariableValue(localElement.parameters[param])"
                @change="(val) => setParamValue(param, val)"
                :variables="variables"
                :allowCustom="true"
                :placeholder="'Valeur pour ' + param"
              />
          </div>
      </div>
      
      <!-- Preview Section -->
      <div v-if="previewText" class="preview-section">
        <label class="section-label">Aperçu</label>
        <div class="whatsapp-preview">
            <div class="message-bubble">
                {{ previewText }}
            </div>
            <div class="preview-note">Ceci est un aperçu approximatif. Le rendu réel dépend de WhatsApp.</div>
        </div>
      </div>

      <div class="edit-actions">
        <button class="cancel-btn" @click.stop="cancelEditing">Annuler</button>
        <button class="save-btn" @click.stop="saveChanges">Enregistrer</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'; 
import { consoleError } from '@/utils/logger';
import VariableSelector from '@/components/common/VariableSelector.vue'; 

export default {
  name: 'TemplateElement',
  components: {
    VariableSelector
  },
  props: {
    element: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    variables: {
      type: Array,
      default: () => []
    },
    chatbot: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      isEditing: false,
      localElement: null,
      templates: [],
      loading: false,
      currentTemplateParams: []
    };
  },
  created() {
    this.initLocalData();
    if (this.localElement.sender) {
        this.fetchTemplates(); // Try to pre-fetch if sender exists
    }
  },
  watch: {
    element: {
      handler() {
        if (!this.isEditing) {
          this.initLocalData();
        }
      },
      deep: true
    }
  },
  computed: {
      // Helper to find status of selected template
      selectedTemplateStatus() {
          if (!this.localElement.templateName || this.templates.length === 0) return 'UNKNOWN';
          const t = this.templates.find(tpl => tpl.name === this.localElement.templateName);
          return t ? t.status : 'UNKNOWN';
      },
      statusColor() {
          const status = this.selectedTemplateStatus;
          if (status === 'APPROVED') return '#10b981'; // Green
          if (status === 'REJECTED') return '#ef4444'; // Red
          if (status === 'PENDING') return '#f59e0b'; // Orange
          return '#6b7280'; // Gray
      },
      currentTemplateBody() {
        if (!this.localElement.templateName || this.templates.length === 0) return '';
        const t = this.templates.find(tpl => tpl.name === this.localElement.templateName);
        if (!t || !t.components) return '';
        const body = t.components.find(c => c.type === 'BODY');
        return body ? body.text : '';
      },
      previewText() {
        let text = this.currentTemplateBody;
        if (!text) return '';
        
        // Replace parameters
        if (this.localElement.parameters) {
            Object.keys(this.localElement.parameters).forEach(key => {
                const val = this.localElement.parameters[key];
                // Replace both {{key}} and {{ key }} just in case
                // Simple replacement
                text = text.split(`{{${key}}}`).join(val || `{{${key}}}`);
            });
        }
        return text;
      }
  },
  methods: {
    getVariableValue(val) {
      if (!val) return '';
      const match = val.match(/^\{\{(.+)\}\}$/);
      return match ? match[1] : val;
    },
    setVariableValue(field, val) {
      if (!val) {
        this.localElement[field] = '';
        return;
      }
      const isVar = this.variables.some(v => v.id === val);
      if (isVar) {
        this.localElement[field] = `{{${val}}}`;
      } else {
        this.localElement[field] = val;
      }
    },
    setParamValue(param, val) {
      if (!val) {
        this.localElement.parameters[param] = '';
        return;
      }
      const isVar = this.variables.some(v => v.id === val);
      if (isVar) {
        this.localElement.parameters[param] = `{{${val}}}`;
      } else {
        this.localElement.parameters[param] = val;
      }
    },
    initLocalData() {
      this.localElement = JSON.parse(JSON.stringify(this.element));
      
      // Defaults - Use chatbot display_phone_number if available
      if (!this.localElement.sender) {
          this.localElement.sender = this.chatbot?.display_phone_number || ''; 
      }
      if (!this.localElement.parameters) this.localElement.parameters = {};
      
      // Ensure metadata fields exist
      if (!this.localElement.category) this.localElement.category = ''; 
      if (!this.localElement.language) this.localElement.language = '';
      if (!this.localElement.status) this.localElement.status = '';
      if (!this.localElement.templateId) this.localElement.templateId = '';
      if (this.localElement.sub_category === undefined) this.localElement.sub_category = null;
      
      this.extractParamsFromFetch(); 
    },
    async fetchTemplates() {
        if (!this.localElement.sender) return;
        this.loading = true;
        try {
            const response = await axios.get(`https://api.peelo.io/template/list/${this.localElement.sender}`);
            if (response.data && response.data.success && response.data.data && response.data.data.data) {
                this.templates = response.data.data.data;
                // If we are editing, refresh params based on loaded templates
                this.extractParamsFromFetch();
            }
        } catch (error) {
            consoleError("Error fetching templates:", error);
            this.$emit('notification', { message: "Erreur chargement templates", type: "error" });
        } finally {
            this.loading = false;
        }
    },
    onTemplateChange() {
        this.localElement.parameters = {}; // Reset params on change
        this.extractParamsFromFetch(true); // Indicate change to update category
    },
    extractParamsFromFetch(isChange = false) {
        if (!this.localElement.templateName || this.templates.length === 0) return;
        
        const selected = this.templates.find(t => t.name === this.localElement.templateName);
        if (!selected) return;

        // Update metadata if we found the template (especially on change)
        if (selected) {
             if (isChange || !this.localElement.category) {
                this.localElement.category = (selected.category || '').toLowerCase();
             }
             if (isChange || !this.localElement.language) {
                 this.localElement.language = selected.language;
             }
             if (isChange || !this.localElement.status) {
                 this.localElement.status = selected.status;
             }
             if (isChange || !this.localElement.templateId) {
                 // Store Facebook Template ID
                 this.localElement.templateId = selected.id;
             }
             if (isChange || this.localElement.sub_category === undefined) {
                 // Handle sub_category which might be missing/null
                 this.localElement.sub_category = selected.sub_category || null; 
             }
        }

        let params = new Set();
        if (selected.components) {
            selected.components.forEach(comp => {
                if (comp.type === 'BODY' && comp.text) {
                     const matches = comp.text.match(/{{([^}]+)}}/g);
                     if (matches) {
                         matches.forEach(m => params.add(m.replace(/{{|}}/g, '').trim()));
                     }
                }
            });
        }
        this.currentTemplateParams = Array.from(params);
    },
    startEditing() {
      this.initLocalData();
      this.isEditing = true;
      if (this.templates.length === 0) this.fetchTemplates();
    },
    cancelEditing() {
      this.isEditing = false;
      this.initLocalData();
    },
    saveChanges() {
      this.$emit('update', this.localElement);
      this.isEditing = false;
      this.$emit('notification', {
        message: 'Template mis à jour',
        type: 'success'
      });
    }
  }
}
</script>

<style scoped>
.template-element {
  background: #ffffff;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  border: 1px solid #e5e7eb; 
}

.element-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 16px;
  background: linear-gradient(to right, #f8fafc, #f1f5f9);
  border-bottom: 1px solid #f1f5f9;
}

.element-type-badge {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  color: #059669;
  font-size: 0.875rem;
}

.element-type-badge svg {
  color: #059669;
}

.element-actions {
  display: flex;
  gap: 8px;
}

.action-btn {
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 50%;
  background: white;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.action-btn:hover {
  transform: scale(1.1);
}

.element-content {
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  cursor: pointer;
}

.info-row {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.9rem;
}

.label {
  font-weight: 600;
  color: #374151;
  min-width: 80px;
}

.value {
  color: #111827;
  background: #f3f4f6;
  padding: 2px 8px;
  border-radius: 4px;
}

.edit-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 8px 12px;
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  color: #4b5563;
  font-size: 0.85rem;
  margin-top: 8px;
  align-self: flex-end;
}

.element-edit-form {
  padding: 16px;
  background: #ffffff;
}

.form-group {
  margin-bottom: 12px;
}

.form-group label {
  display: block;
  font-size: 0.85rem;
  font-weight: 600;
  color: #374151;
  margin-bottom: 6px;
}

.form-input, .form-select {
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  font-size: 0.9rem;
  color: #1f2937;
  background: white;
}

.small-btn {
    padding: 8px;
    border: 1px solid #d1d5db;
    background: white;
    border-radius: 8px;
    cursor: pointer;
    color: #4b5563;
}

.parameters-section {
    margin-top: 16px;
    padding: 12px;
    background: #f9fafb;
    border-radius: 8px;
    border: 1px dashed #d1d5db;
}

.section-label {
    display: block;
    margin-bottom: 10px;
    font-weight: bold;
    color: #374151;
    font-size: 0.9em;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.small-group {
    margin-bottom: 8px;
}
.small-group label {
    font-size: 0.8em;
    color: #047857;
}

.edit-actions {
  display: flex;
  gap: 12px;
  margin-top: 20px;
}

.save-btn, .cancel-btn {
  flex: 1;
  padding: 8px 16px;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
}

.save-btn {
  background: #059669;
  color: white;
  border: none;
}

.cancel-btn {
  background: white;
  color: #6b7280;
  border: 1px solid #e5e7eb;
}

.status-badge {
    color: white;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 0.8em;
    font-weight: bold;
}

.variable-input-wrapper {
    display: flex;
    gap: 4px;
}

.variable-picker {
    width: 30px;
    padding: 0;
    border: 1px solid #a7f3d0;
    background: white;
    border-radius: 8px;
    cursor: pointer;
    color: transparent; /* Hide text, show icon ideally, but simple select for now */
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23059669' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'%3E%3C/polyline%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: center;
    overflow: hidden;
}
/* Hack to show options but hide selected text visually to keep it like an icon button */
.variable-picker option {
    color: black;
}

.sender-info {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 12px;
    background: #f0fdf4;
    border: 1px solid #bbf7d0;
    border-radius: 8px;
}

.phone-badge {
    display: flex;
    align-items: center;
    gap: 8px;
    font-weight: 600;
    color: #15803d;
    font-size: 0.95rem;
    flex: 1;
}

.refresh-btn {
    border: none;
    background: transparent;
    color: #15803d;
    font-size: 1rem;
    padding: 4px;
}
.refresh-btn:hover {
    color: #166534;
    background: rgba(21, 128, 61, 0.1);
}

.preview-section {
    margin-top: 16px;
}

.whatsapp-preview {
    background: #e2e8f0; /* Neutral gray/blue instead of whatsapp beige for dashboard consistency */
    padding: 16px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.message-bubble {
    background: white;
    padding: 8px 12px;
    border-radius: 0 12px 12px 12px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.1);
    color: #1f2937;
    font-size: 0.95rem;
    line-height: 1.5;
    white-space: pre-wrap;
    align-self: flex-start;
    max-width: 90%;
    position: relative;
}

.message-bubble::before {
    content: '';
    position: absolute;
    left: -8px;
    top: 0;
    width: 0;
    height: 0;
    border: 8px solid transparent;
    border-top-color: white;
    border-right-color: white;
    border-bottom: 0;
    margin-top: 0;
    margin-right: -10px;
}

.preview-note {
    font-size: 0.75rem;
    color: #64748b;
    text-align: center;
    margin-top: 4px;
}

.empty-preview {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    gap: 10px;
    color: #6b7280;
}

.status-indicator {
    position: absolute;
    top: 12px;
    right: 12px;
}

.edit-button-overlay {
    position: absolute;
    bottom: 12px;
    right: 12px;
    width: 32px;
    height: 32px;
    background: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    color: #6b7280;
    opacity: 0;
    transition: opacity 0.2s;
}

.element-content:hover .edit-button-overlay {
    opacity: 1;
}

.element-content {
    position: relative;
    /* Other existing properties... will be inherited/merged if already defined above */
}
.category-badge {
    font-size: 0.7em;
    padding: 2px 6px;
    background: #e2e8f0;
    color: #475569;
    border-radius: 4px;
    text-transform: uppercase;
    font-weight: 600;
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.spin {
  animation: spin 1s linear infinite;
}
</style>
